import { Scale } from "lucide-react";

import { IgTooltip } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";

interface AutoScaleColumnProps {
  autoScale: boolean;
}
export const BillingAutoScaleIcon = ({ autoScale }: AutoScaleColumnProps) => {
  const theme = useTheme();
  return autoScale ? (
    <IgTooltip title={"Shopify Order Scaling Enabled"}>
      <Scale size={18} />
    </IgTooltip>
  ) : (
    <IgTooltip title={"Shopify Order Scaling Disabled"}>
      <Scale color={theme.palette.text.placeholder} size={18} />
    </IgTooltip>
  );
};
